var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioLines2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 52,
    viewBox: "0 0 324 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 17V17L1 35V35L1 17Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20V20L4 32V32L4 20Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8V8L7 44V44L7 8Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17V17L10 35V35L10 17Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 3V3V49V49V3Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11V11L16 41V41L16 11Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19 20V20L19 32V32L19 20Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22 23V23L22 29V29L22 23Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25 17V17L25 35V35L25 17Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28 20V20L28 32V32L28 20Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31 8V8L31 44V44L31 8Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34 17V17L34 35V35L34 17Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37 3V3V49V49V3Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40 11V11L40 41V41L40 11Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43 20V20L43 32V32L43 20Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M46 23V23L46 29V29L46 23Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M49 17V17L49 35V35L49 17Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M52 20V20L52 32V32L52 20Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M55 8V8L55 44V44L55 8Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M58 17V17L58 35V35L58 17Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M61 3V3V49V49V3Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M64 11V11L64 41V41L64 11Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M67 20V20L67 32V32L67 20Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M70 23V23L70 29V29L70 23Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M73 17V17L73 35V35L73 17Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M76 20V20L76 32V32L76 20Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M79 8V8L79 44V44L79 8Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M82 17V17L82 35V35L82 17Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M85 3V3V49V49V3Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M88 11V11L88 41V41L88 11Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M91 20V20L91 32V32L91 20Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M94 23V23L94 29V29L94 23Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M97 17V17L97 35V35L97 17Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M100 20V20L100 32V32L100 20Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M103 8V8L103 44V44L103 8Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M106 17V17L106 35V35L106 17Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M109 3V3V49V49V3Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M112 11V11L112 41V41L112 11Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M115 20V20L115 32V32L115 20Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M118 23V23L118 29V29L118 23Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M121 17V17L121 35V35L121 17Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M124 20V20L124 32V32L124 20Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M127 8V8L127 44V44L127 8Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M130 17V17L130 35V35L130 17Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M133 3V3V49V49V3Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M136 11V11L136 41V41L136 11Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M139 20V20L139 32V32L139 20Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M142 23V23L142 29V29L142 23Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M145 17V17L145 35V35L145 17Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M148 20V20L148 32V32L148 20Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M151 8V8L151 44V44L151 8Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M154 17V17L154 35V35L154 17Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M157 3V3V49V49V3Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M160 11V11L160 41V41L160 11Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M163 20V20L163 32V32L163 20Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M166 23V23L166 29V29L166 23Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M169 17V17L169 35V35L169 17Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M172 20V20L172 32V32L172 20Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M175 8V8L175 44V44L175 8Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M178 17V17L178 35V35L178 17Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M181 3V3V49V49V3Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M184 11V11L184 41V41L184 11Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M187 20V20L187 32V32L187 20Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M190 0V0L190 52V52L190 0Z",
    stroke: "#F97066",
    strokeMiterlimit: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 192,
    y1: 25.5,
    x2: 324,
    y2: 25.5,
    stroke: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioLines2);
export default __webpack_public_path__ + "static/media/audio_lines2.131950ba539c397fb61e9c582c076d0f.svg";
export { ForwardRef as ReactComponent };